module.exports = __webpack_public_path__ + "img/vodafone-logo.e1ebdc18.png";